import { render, staticRenderFns } from "./DeliveryPrepareIframe.vue?vue&type=template&id=4bcb97be&"
import script from "./DeliveryPrepareIframe.vue?vue&type=script&lang=ts&"
export * from "./DeliveryPrepareIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports